module.exports = __webpack_public_path__ + "img/OfferImg.24c73e67.svg";